export default __webpack_public_path__ + "static/media/blaster.659c81d6.png";